export default __webpack_public_path__ + "static/media/640_business05-es-mobile.bc4f60c0.png";